
import { Card, CardContent, Divider, Grid, makeStyles, Theme, Typography, useTheme } from '@material-ui/core';
import { PilotStatsContentProps, PilotData } from '../../../Interfaces/Interfaces';

const useStyles = makeStyles((theme: Theme) => ({
	typo1: {
		backgroundColor:theme.palette.primary.main
	},
	typo2: {
		color: theme.palette.secondary.main
	},
	root: {
		minWidth: 300,
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)',
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 50,
	},
}));



const PilotStatsContent = (props:PilotStatsContentProps) => {
	const theme = useTheme();
	const classes = useStyles(theme);

	return (
		<Grid item >
			<Grid
				container
				justify="center"
				alignItems="center"
				className={classes.pos}
				spacing={2}
			>
				{props?.data.map((cardData:PilotData,index:number) => {
					return (
						<Grid key={index} item >
							<Card className={classes.root}>
								<CardContent className={classes.typo1}>
									<Typography align="center" className={classes.typo2} >
										{cardData.title}
									</Typography>
								</CardContent>
								<Divider /> 
								<CardContent>
									<Typography align="center">
										{cardData.value}
									</Typography>
								</CardContent>
							</Card>
						</Grid>
					)
				})}
			</Grid>
		</Grid>
	)
}
export default PilotStatsContent ;
